import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import React from "react";
import DropDownList from "../../../../../../ReusableComponents/DropDownList/DropDownList";
import ConfirmPopUpMobilization from "../../../MobilizationData/ConfirmPopUp/ConfirmPopUpMobilization";

export default function AbscondingRunPopup({
  PopUp,
  setPopUp,
  propData,
  setTrigger,
  trigger,
}) {
  const [yesPopup, setYesPopup] = useState(false);
  const [formData, setFormData] = useState({
    demobilizationDate: "",
    changeStatus: "",
  });

  const [loading, setLoading] = useState(false);
  var list = [
    { value: "IDLE" },
    { value: "REPORTED ABSCONDING IN MUQEEM" },
    // { value: "CANCEL REPORTED ABSCONDING" },
  ];
  const statusValue = (event) => {
    setFormData({
      ...formData,
      changeStatus: event.target.value,
    });
  };

  console.log("formData......", formData);
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>

          <div className="form-control w-full">
            <label className="label">
              <span className="label-text">CHANGE STATUS</span>
            </label>
            <DropDownList setValue={statusValue} presetValues={list} />
          </div>
          {formData?.changeStatus === "IDLE" ? (
            ""
          ) : (
            <div className="form-control w-full">
              <label className="label">
                <span className="label-text">REPORTED ABSCONDING DATE</span>
              </label>

              <input
                type="date"
                className="input input-sm input-bordered"
                required
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    demobilizationDate: e.target.value,
                  })
                }
              />
            </div>
          )}

          <div className="w-full">
            <div className="w-full flex flex-col gap-3 my-3 p-5">
              <div className="flex gap-3 w-full justify-center">
                <button
                  className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                  onClick={() => setYesPopup(true)}
                >
                  <p>Submit</p>
                  {loading ? <CgSpinner className="animate-spin" /> : ""}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {yesPopup ? (
        <ConfirmPopUpMobilization
          PopUp={yesPopup}
          setYesPopup={setYesPopup}
          title={
            formData.changeStatus !== ""
              ? "ARE YOU SURE YOU WANT TO CHANGE THE STATUS?"
              : "ARE YOU SURE YOU WANT TO CANCEL THE REPORTED ABSCONDING?"
          }
          callBack={"call Api Function"}
          formData={formData}
          propData={propData}
          setTrigger={setTrigger}
          trigger={trigger}
          setPopUp={setPopUp}
        />
      ) : (
        ""
      )}
    </>
  );
}
